const catchErrorApi = function (response, vue) {
  let code = response.response && response.response.data && response.response.data.code ? parseInt(response.response.data.code) : undefined
  let message = response.response && response.response.data && response.response.data.error ? response.response.data.error : undefined
  switch (code) {
    case 4 :
      vue.$notify.error({title: 'Error', message: vue.$t('notifications.error.session')})
      vue.$store.dispatch('user/logout')
      return vue.$router.push('/signin')
    default : {
      if (message !== undefined) {
        vue.$notify.error({title: 'Error', message: response.response.data.error})
      } else {
        vue.$notify.error({title: 'Error', message: vue.$t('notifications.unknown')})
      }
    }
  }
}

export default catchErrorApi



// WEBPACK FOOTER //
// ./src/errors.js